import { Operation } from '@apollo/client/link/core/types';

export default (operation: Operation) =>
  operation.query.definitions.length > 0 &&
  operation.query.definitions[0].kind === 'OperationDefinition' &&
  operation.query.definitions[0].operation === 'mutation';
